import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { http } from "../../../axios/axios";
import ProductCard from "../../ProductCard";
import SectionHeader from "../../SectionHeader";
import MediaRichDetail from "../../DetailPage/MediaRichDetail";

export default function SolutionDetails() {
  const { slug } = useParams();
  const [solution, setSolution] = useState(null);
  const [latestProducts, setLatestProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    const fetchSolution = async () => {
      try {
        setLoading(true);
        const [solutionRes, productsRes] = await Promise.all([
          http.get(`solutions/${slug}`),
          http.get("products/latest"),
        ]);
        setSolution(solutionRes.data.data);
        setLatestProducts(productsRes.data.products || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchSolution();
  }, [slug]);

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center bg-white"><div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600" /></div>;
  }

  if (!solution) {
    return <div className="flex min-h-screen items-center justify-center"><p className="text-gray-600">Solution not found.</p></div>;
  }

  const seoData = solution.seo || {};
  const schemaScript = solution.schemaScript
    ? typeof solution.schemaScript === "string"
      ? solution.schemaScript
      : JSON.stringify(solution.schemaScript)
    : null;

  return (
    <>
      <Helmet>
        <title>{seoData.title || solution.bannerTitle}</title>
        <meta name="description" content={seoData.description || solution.bannerSubtitle} />
        <meta name="keywords" content={Array.isArray(seoData.keywords) ? seoData.keywords.join(", ") : seoData.keywords || ""} />
        {schemaScript && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaScript }} />}
      </Helmet>
      <MediaRichDetail item={solution} type="solution" />
      {latestProducts.length > 0 && (
        <section className="bg-slate-50 py-14 lg:py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeader badge="Recommended Products" title="Explore our products" description="Reliable security products selected to support this solution." showLine={false} />
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">{latestProducts.map((product) => <ProductCard key={product?._id} item={product} />)}</div>
          </div>
        </section>
      )}
    </>
  );
}
